import { useEffect } from "react";

const ICONS = [
  { rel: "icon", href: "/favicon.svg?v=7", type: "image/svg+xml" },
  { rel: "icon", href: "/favicon.png?v=7", type: "image/png", sizes: "32x32" },
  { rel: "shortcut icon", href: "/favicon.ico?v=7" },
  { rel: "apple-touch-icon", href: "/apple-touch-icon.png?v=7" },
];

function upsertLink(attrs) {
  const selector = attrs.type
    ? `link[rel="${attrs.rel}"][type="${attrs.type}"]`
    : `link[rel="${attrs.rel}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([key, value]) => {
    el.setAttribute(key, value);
  });
}

/** Forces the Flash coin favicon on every client-rendered page. */
export default function SiteFavicon() {
  useEffect(() => {
    ICONS.forEach(upsertLink);
  }, []);
  return null;
}
